export default __webpack_public_path__ + "static/media/imgPdf.ad70f997.png";